/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 350:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const i18nJsxCreator = __webpack_require__(69);
const I18nBase = __webpack_require__(319);

/**
 * I18n
 */
class I18n extends I18nBase {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super(options);
    this.jsx = {
      gettext: (text, settings) => {
        if (!settings) return null;
        const translation = this.getTranslation(text);
        return i18nJsxCreator.create(translation, settings);
      },
      ngettext: (text, nText, settings) => {
        if (!settings) return null;
        const translation = this.getPluralTranslation(text, nText, settings.quantity);
        return i18nJsxCreator.create(translation, settings);
      },
      pgettext: (msgctxt, text, settings) => {
        if (!settings) return null;
        const translation = this.getTranslation(text, msgctxt);
        return i18nJsxCreator.create(translation, settings);
      },
      npgettext: (msgctxt, text, nText, settings) => {
        if (!settings) return null;
        const translation = this.getPluralTranslation(text, nText, settings.quantity, msgctxt);
        return i18nJsxCreator.create(translation, settings);
      }
    };
  }
}

/**
 * Expose I18n
 */
module.exports = I18n;

/***/ }),

/***/ 319:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(530);
__webpack_require__(298);
__webpack_require__(553);
__webpack_require__(199);
__webpack_require__(722);
__webpack_require__(658);
__webpack_require__(669);
__webpack_require__(26);
/**
 * I18nBase (without React)
 */
class I18nBase {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.translations = options.translations;
    this.locale = options.locale;
    this.notifyMissingTranslations = options.notifyMissingTranslations;
    this.notify = options.notify || function noop() {};
  }

  /**
   * Given some arrays, convert those in a unique array
   * Usage: flattenArray([[1], [2], [[2,4],2]]); // [1,2,2,4,2]
   * @return {array} The array flatten
   */
  flattenArray(arrays) {
    return arrays.reduce((acc, val) => acc.concat(Array.isArray(val) ? this.flattenArray(val) : val), []);
  }

  /**
   * Given a text with arguments, replace those arguments in the text.
   * Usage: replaceArguments('This is {0}, right {0}?', 'John'); // This is John, right John?
   * @return {string} The text modified
   */
  replaceArguments() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    let out = args[0];
    const replacements = [];
    args.forEach((argument, index) => {
      replacements.push(args[index + 1]);
    });
    replacements.forEach((replacement, index) => {
      // Use a global regex replace because of possible infinite loops with while implementation
      out = out.replace(new RegExp(`\\{${index}\\}`, 'g'), replacement);
    });
    return out;
  }

  /**
   * Given a text and a msgctxt, returns the translation id.
   * Usage: getTranslationId('context', 'My message'); // 'context\u0004My message'
   * It is using the unicode '\u0004' as prefix because po2json package has this format for context keys.
   * @see https://github.com/melisource/fury_frontend-i18n/blob/master/src/po2json/parse.js#L80
   * @return {string} The translation id.
   */
  getTranslationId(text, msgctxt) {
    return typeof msgctxt === 'string' ? `${msgctxt}\u0004${text}` : text;
  }

  /**
   * Given a text, returns the translation.
   * Usage: getTranslation('My message'); // My message
   * @return {string} The translation
   */
  getTranslation(text, msgctxt) {
    const id = this.getTranslationId(text, msgctxt);
    const tr = this.translations[id];
    if (tr && tr[1] && tr[1].length > 0) {
      return tr[1];
    }
    if (this.notifyMissingTranslations) {
      this.notify(this.locale, text);
    }
    return text;
  }

  /**
   * Given a text and a quantity, returns the translation of the text depending on whether it is singular or plural.
   * Usage: getPluralTranslation('You have {0} message', 'You have {0} messages', 3); // You have 3 messages'
   * @return {string} The translation
   */
  getPluralTranslation(text, nText, quantity, msgctxt) {
    const id = this.getTranslationId(text, msgctxt);
    const tr = this.translations[id];

    // Singular text
    if (quantity === 1) {
      if (tr && tr[1] && tr[1].length) {
        return tr[1];
      }
      return text;
    }

    // Plural text
    if (tr && tr[2] && tr[2].length) {
      return tr[2];
    }
    return nText;
  }

  /**
   * Given a text, return the translation with its arguments replaced.
   * Usage: gettext('This is {0}, right {0}?', 'John') // This is John, right John?
   * @return {string} The text modified and replaced
   */
  gettext(text) {
    const translation = this.getTranslation(text);
    for (var _len2 = arguments.length, replacements = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      replacements[_key2 - 1] = arguments[_key2];
    }
    return this.replaceArguments.apply(null, this.flattenArray([translation, replacements]));
  }

  /**
   * Given a text in singular, a text in plural and a quantity, return the translation with its arguments replaced.
   * Usage: ngettext('{0}, You have {1} message', '{0}, You have {1} messages', 6, ['John', 6])
   * // John, You have 6 messages
   * @return {string} The text modified and replaced
   */
  ngettext(text, nText, quantity) {
    const translation = this.getPluralTranslation(text, nText, quantity);
    for (var _len3 = arguments.length, replacements = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      replacements[_key3 - 3] = arguments[_key3];
    }
    return this.replaceArguments.apply(null, this.flattenArray([translation, replacements]));
  }

  /**
   * Given a context and a text, return the translation with its arguments replaced.
   * Usage: pgettext('question', This is {0}, right {0}?', 'John') // This is John, right John?
   * @return {string} The text modified and replaced
   */
  pgettext(msgctxt, text) {
    const translation = this.getTranslation(text, msgctxt);
    for (var _len4 = arguments.length, replacements = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
      replacements[_key4 - 2] = arguments[_key4];
    }
    return this.replaceArguments.apply(null, this.flattenArray([translation, replacements]));
  }

  /**
   * Given a context, a text in singular, a text in plural and a quantity, return the translation with its arguments replaced.
   * Usage: npgettext('information', {0}, You have {1} message', '{0}, You have {1} messages', 6, ['John', 6])
   * // John, You have 6 messages
   * @return {string} The text modified and replaced
   */
  npgettext(msgctxt, text, nText, quantity) {
    const translation = this.getPluralTranslation(text, nText, quantity, msgctxt);
    for (var _len5 = arguments.length, replacements = new Array(_len5 > 4 ? _len5 - 4 : 0), _key5 = 4; _key5 < _len5; _key5++) {
      replacements[_key5 - 4] = arguments[_key5];
    }
    return this.replaceArguments.apply(null, this.flattenArray([translation, replacements]));
  }
}

/**
 * Expose I18n
 */
module.exports = I18nBase;

/***/ }),

/***/ 69:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(971)["default"]);
const React = __webpack_require__(15);
const I18nJsx = __webpack_require__(340);

// This class exists only not to include the React scope in the i18n class file.
class i18nJsxCreator {
  static create(text, settings) {
    return /*#__PURE__*/_jsx(I18nJsx, {
      crowdinKey: text,
      settings: settings
    });
  }
}
module.exports = i18nJsxCreator;

/***/ }),

/***/ 978:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(971)["default"]);
var _reactJsxRuntime = __webpack_require__(732);
__webpack_require__(602);
__webpack_require__(530);
__webpack_require__(199);
__webpack_require__(722);
__webpack_require__(658);
__webpack_require__(669);
__webpack_require__(26);
__webpack_require__(697);
const React = __webpack_require__(15);
const {
  regexps,
  markups
} = __webpack_require__(944);

/**
 * Prepare replacements
 * Iterate over components settings and prepare replacements for given index placeholders
 * @param {Object} components
 * @returns {Object}
 */
function prepareReplacements(components) {
  const renderFunctionReplacements = new Map();
  const reactNodesReplacements = new Map();
  const textReplacements = [];
  Object.keys(components).forEach((key, index) => {
    const el = components[Number(key)];
    if (typeof el === 'function') {
      renderFunctionReplacements.set(index, el);
      // preserve the renderFunction position on translation input parameters
      textReplacements.push({
        index: key,
        replacement: `${markups.start}${markups.function}((${index}))${markups.function}${markups.end}`
      });
    } else {
      reactNodesReplacements.set(index, el);
      // preserve the element position on translation input parameters
      textReplacements.push({
        index: key,
        replacement: `${markups.start}${markups.function}((${index}))${markups.function}${markups.end}`
      });
    }
  });
  return {
    textReplacements,
    reactNodesReplacements,
    renderFunctionReplacements
  };
}

/**
 * Generates react component based on original translation and prepared replacements.
 * Creates react element per replacement
 * @param {String} translation
 * @param {Object} replacements
 * @returns
 */
function injectReactComponentsInTranslatedText(translation, replacements) {
  const {
    textReplacements,
    reactNodesReplacements,
    renderFunctionReplacements
  } = replacements;
  textReplacements.forEach(_ref => {
    let {
      index,
      replacement
    } = _ref;
    // Use a global regex replace because of possible infinite loops with while implementation
    // eslint-disable-next-line no-param-reassign
    translation = translation.replace(regexps.placeholders(index), `${replacement}`);
  });
  const split = translation.split(regexps.split);
  const children = split.reduce((acc, current, index, total) => {
    var _current$match;
    const itemKey = (_current$match = current.match(regexps.components)) === null || _current$match === void 0 ? void 0 : _current$match[1];
    if (itemKey === undefined) return [...acc, current];
    const innerText = total[index + 1];
    const closingTag = total[index + 2];
    const hasClosingTag = closingTag === `${markups.function}((${itemKey}))${markups.function}`;
    if (hasClosingTag) {
      // delete the inner text, already extracted in the innerText variable
      delete total[index + 1];
      // delete the closing tag
      delete total[index + 2];
    }
    let reactElement = reactNodesReplacements.get(+itemKey);
    if (reactElement === undefined) {
      const renderFunction = renderFunctionReplacements.get(+itemKey);
      reactElement = renderFunction(innerText);
    }
    const key = `${index}_${innerText}`;
    const fragment = React.createElement(React.Fragment, {
      key
    }, reactElement);
    return [...acc, fragment];
  }, []);
  return React.createElement(React.Fragment, null, children);
}

/**
 * Return translated text react element with components settings
 */
function I18nJsxWithComponents(props) {
  const {
    wrapper,
    text,
    components,
    className
  } = props;
  const Wrapper = wrapper;
  const componentsReplacements = prepareReplacements(components);
  const translatedComponents = injectReactComponentsInTranslatedText(text, componentsReplacements);
  if (!Wrapper) {
    return /*#__PURE__*/_reactJsxRuntime.jsx(_reactJsxRuntime.Fragment, {
      children: translatedComponents
    });
  }
  return /*#__PURE__*/_jsx(Wrapper, {
    className: className
  }, void 0, translatedComponents);
}
module.exports = I18nJsxWithComponents;

/***/ }),

/***/ 559:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(971)["default"]);
const React = __webpack_require__(15);
const {
  interpolate
} = __webpack_require__(944);

/**
 * Return translated text react element with tags settings
 */
function I18nJsxWithTags(props) {
  const {
    wrapper,
    text,
    tags,
    className
  } = props;
  const Wrapper = wrapper;
  return /*#__PURE__*/_jsx(Wrapper, {
    dangerouslySetInnerHTML: {
      __html: interpolate(text, tags)
    },
    className: className
  });
}
module.exports = I18nJsxWithTags;

/***/ }),

/***/ 340:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(971)["default"]);
__webpack_require__(458);
const React = __webpack_require__(15);
const {
  defaultWrapper,
  interpolate
} = __webpack_require__(944);
const I18nJsxWithTags = __webpack_require__(559);
const I18nJsxWithComponents = __webpack_require__(978);

/**
 * Set text based on crowdinKey and do replacements sent in settings
 *
 * @param {String} key Crowdin Key
 * @param {Object} replacements Replacements objects
 * @returns
 */
function getBaseInterpolatedText(key, replacements) {
  let interpolated = key;

  // Replace other placeholders if present. For the cases of ngettext, pgettext, npgettext.
  if (replacements) {
    interpolated = interpolate(interpolated, replacements);
  }
  return interpolated;
}
function I18nJsx(props) {
  const {
    crowdinKey,
    settings
  } = props;
  const {
    wrapper = null,
    className,
    replacements = null,
    tags = null,
    components = null
  } = settings;
  if (components && tags) {
    throw new Error('tags and components properties cannot be used together. See the doc about the use of i18n.jsx properties.');
  }
  const interpolated = getBaseInterpolatedText(crowdinKey, replacements);

  // React Components has been configured. Replace them and get the component
  if (components) {
    return /*#__PURE__*/_jsx(I18nJsxWithComponents, {
      wrapper: wrapper,
      text: interpolated,
      components: components,
      className: className
    });
  }

  // HTML Tags has been configured. Replace them and return component non-scaping HTML
  return /*#__PURE__*/_jsx(I18nJsxWithTags, {
    wrapper: wrapper || defaultWrapper,
    text: interpolated,
    tags: tags,
    className: className
  });
}
module.exports = I18nJsx;

/***/ }),

/***/ 437:
/***/ ((module) => {

/**
 * Default wrapper used for final component
 */
const defaultWrapper = 'div';

/**
 * String markups to be used in react component replacements
 */
const markups = {
  start: '<<EOP__',
  end: '__EOP>>',
  function: 'FN'
};
module.exports = {
  defaultWrapper,
  markups
};

/***/ }),

/***/ 944:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const {
  interpolate
} = __webpack_require__(273);
const {
  markups,
  defaultWrapper
} = __webpack_require__(437);
const regexps = __webpack_require__(202);
module.exports = {
  interpolate,
  markups,
  defaultWrapper,
  regexps
};

/***/ }),

/***/ 202:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(298);
__webpack_require__(553);
__webpack_require__(199);
/* eslint-disable security/detect-non-literal-regexp */
const {
  markups
} = __webpack_require__(437);

/**
 * Regular Expressions used for find and replace on base translations
 */
module.exports = {
  placeholders: index => new RegExp(`\\{${index}\\}`, 'g'),
  split: new RegExp(`${markups.start}|${markups.end}`),
  components: new RegExp(`${markups.function}\\(\\((\\d*)\\)\\)${markups.function}`)
};

/***/ }),

/***/ 273:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(199);
__webpack_require__(722);
/**
 * Replace expressions on given string based on placeholders like {0}
 *
 * @param {String} str
 * @param {Object} values
 * @returns {String} Interpolated string
 */
const interpolate = (str, values) => str.replace(/{(\w+)}/g, (match, expr) => values[String(expr)] || match);
module.exports = {
  interpolate
};

/***/ }),

/***/ 971:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 602:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.iterator.js");

/***/ }),

/***/ 530:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.reduce.js");

/***/ }),

/***/ 458:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.error.cause.js");

/***/ }),

/***/ 298:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.regexp.constructor.js");

/***/ }),

/***/ 553:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.regexp.dot-all.js");

/***/ }),

/***/ 199:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.regexp.exec.js");

/***/ }),

/***/ 722:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.replace.js");

/***/ }),

/***/ 658:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/esnext.iterator.constructor.js");

/***/ }),

/***/ 669:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/esnext.iterator.for-each.js");

/***/ }),

/***/ 26:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/esnext.iterator.reduce.js");

/***/ }),

/***/ 697:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/web.dom-collections.iterator.js");

/***/ }),

/***/ 15:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 732:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(350);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;